import React from 'react';

// Nexus Core Design System (DESIGN.md §6) - アンダーラインタイプ
// フォーカス時、ライン中央から両端に Nexus Blue が広がる (.underline-input ::after)
export default function Input({
  label,
  labelRight,
  error,
  required,
  icon,
  iconRight,
  className = '',
  wrapperClassName = '',
  ...props
}) {
  const inputId = props.id || props.name || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`leading-normal ${wrapperClassName}`}>
      {(label || labelRight) && (
        <div className="flex justify-between items-center mb-1.5">
          {label ? (
            <label htmlFor={inputId} className="block text-xs text-text-secondary">
              {label}
              {required && <span className="text-red-500 ml-1">*</span>}
            </label>
          ) : <span />}
          {labelRight}
        </div>
      )}
      <div
        className={`underline-input relative rounded-t-md transition-colors hover:bg-light-neutral focus-within:bg-light-neutral ${
          error ? 'underline-input-error' : ''
        }`}
      >
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-outline pointer-events-none">
            {icon}
          </div>
        )}
        <input
          id={inputId}
          className={`
            block w-full px-3 py-2.5 text-sm text-text-primary
            bg-transparent border-b transition-colors
            placeholder:text-outline-variant
            focus:outline-none
            disabled:opacity-60 disabled:cursor-not-allowed
            ${icon ? 'pl-10' : ''}
            ${iconRight ? 'pr-10' : ''}
            ${error ? 'border-red-400' : 'border-border-light'}
            ${className}
          `}
          {...props}
        />
        {iconRight && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-outline">
            {iconRight}
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1.5 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}

// Textarea variant
export function Textarea({
  label,
  error,
  required,
  className = '',
  wrapperClassName = '',
  rows = 4,
  ...props
}) {
  const textareaId = props.id || props.name || `textarea-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`leading-normal ${wrapperClassName}`}>
      {label && (
        <label
          htmlFor={textareaId}
          className="block text-sm font-medium text-slate-700 mb-1.5"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        id={textareaId}
        rows={rows}
        className={`
          w-full px-3 py-2 text-base text-slate-900
          border rounded-lg
          transition-colors
          placeholder:text-slate-400
          focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500
          disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed
          resize-y
          ${error ? 'border-red-300 focus:ring-red-500/50 focus:border-red-500' : 'border-slate-300'}
          ${className}
        `}
        {...props}
      />
      {error && (
        <p className="mt-1.5 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}
